import { render, staticRenderFns } from "./SidebarOptionsPanel.vue?vue&type=template&id=6a5324c9"
import script from "./SidebarOptionsPanel.vue?vue&type=script&lang=js"
export * from "./SidebarOptionsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports